import heroOne from '../assets/header-1.jpeg';
import heroTwo from '../assets/header-2.jpeg';

export const departments = [
  {
    key: "general-surgery",
    name: "General surgery",
    image: "/specialties/General Surgery.jfif",
    detail: "General surgical consultations and procedures with focused pre- and post-operative care.",
  },
  {
    key: "obgyn",
    name: "Gynae Surgery",
    image: "/specialties/Gynecology.jfif",
    detail: "Gynecological surgical care supported by experienced specialists and modern facilities.",
  },
  {
    key: "neurosurgery",
    name: "Neuro Surgery",
    image: "/specialties/Neurology.jfif",
    detail: "Brain, spine, and nerve surgical care with careful evaluation and treatment planning.",
  },
  {
    key: "pediatrics",
    name: "Pediatric Surgery",
    image: "/specialties/Pediatrics.jfif",
    detail: "Surgical care for children delivered with age-appropriate support and attention.",
  },
  {
    key: "urology",
    name: "Urology",
    image: "/specialties/Urology.jfif",
    detail: "Urology care for urinary and male reproductive health conditions.",
  },
  {
    key: "orthopedics",
    name: "Orthopedic Surgery",
    image: "/specialties/Orthopedics.jfif",
    detail: "Bone, joint, spine, and injury surgery with focused diagnosis and treatment.",
  },
  {
    key: "plastic-surgery",
    name: "Plastic Surgery",
    image: "/specialties/Plastic Surgery.jfif",
    detail: "Reconstructive and aesthetic procedures with careful surgical planning.",
  },
  {
    key: "general-surgery",
    name: "Bariatic Surgery",
    image: "/specialties/General Surgery.jfif",
    detail: "Bariatric surgical care for weight management and related health conditions.",
  },
  {
    key: "ent",
    name: "ENT surgery",
    image: "/specialties/ENT.jfif",
    detail: "Ear, nose, and throat surgical care with specialist evaluation and treatment.",
  },
  {
    key: "gastroenterology",
    name: "Gastro surgery",
    image: "/specialties/Gastroenterology.jfif",
    detail: "Gastrointestinal surgical consultations and treatment planning.",
  },
];

export const heroSlides = [
  {
    subtitle: "Your Trusted Family Clinic at",
    title: "Capital Care International Hospital",
    titleHighlight: "Hospital",
    desc: "Modern Waiting Areasand World-Class infrastructure for Exceptional patient care.",
    tag: "Premium Healthcare Facility in G-8 Islamabad",
    image: heroOne,
  },
  {
    subtitle: "World-Class Care in",
    title: "Capital Care International Hospital",
    titleHighlight: "Hospital",
    desc: "Your Health, Our Priority - providing Exceptional care with compassion.",
    tag: "World-Class Healthcare in Islamabad",
    image: heroTwo,
  },
];

export const stats = [
  { label: "VIP Room, Executive Room, Private Room" },
  { label: "Advanced ICU" },
  { label: "NICU" },
  { label: "ER" },
  { label: "Modular OT" },
  { label: "Labour Room" },
  { label: "Blood Bank" },
  { label: "Dialysis Centre" },
];

export const healthPackages = [
  { icon: "ðŸ‘¨â€âš•ï¸", cat: "Packages for Men", name: "Executive Health Check-Up for Men", desc: "A comprehensive health check designed specifically for men." },
  { icon: "ðŸ©¸", cat: "Specialized Packages", name: "Comprehensive Diabetes Package", desc: "Stay on top of your diabetes with expert screening and advice." },
  { icon: "ðŸ‘©â€âš•ï¸", cat: "Packages for Women", name: "Complete Health Check-up for Women", desc: "A full women's health screen tailored to your needs." },
  { icon: "ðŸ«€", cat: "Cardiac Care", name: "Cardiac Screening Package", desc: "Protect your heart with our advanced cardiac screening." },
  { icon: "ðŸ¦·", cat: "Dental", name: "Dental Wellness Package", desc: "Keep your smile healthy with our dental wellness check." },
  { icon: "ðŸ”¬", cat: "Urology", name: "Urology Screening Package", desc: "Regular check-ups with a urologist keep you on top of your health." },
  { icon: "ðŸ¤°", cat: "Maternity", name: "Pelvic Pain & Endometriosis Screening", desc: "Take the first step towards better health today." },
  { icon: "ðŸ§¬", cat: "Fertility", name: "Fertility Package", desc: "Expert fertility assessments and personalized care plans." },
  { icon: "ðŸ©º", cat: "General", name: "Annual Health Checkup Package", desc: "Your yearly health baseline â€” comprehensive and convenient." },
];

export const newsItems = [
  { icon: "ðŸ†", date: "16 Oct 2024", title: "Celebrating our Hernia Centre of Excellence" },
  { icon: "ðŸ¤", date: "09 Sep 2024", title: "Sukoon Advance Now Accepted at CSH!" },
  { icon: "ðŸ¥", date: "12 Aug 2024", title: "New Advanced Cardiac Care Unit Opens" },
  { icon: "ðŸŒ", date: "01 Jul 2024", title: "CSH Expands International Patient Services" },
];

export const leaders = [
  { name: "Saeed Rafiq", role: "Business Development", emoji: "ðŸ‘¨â€ðŸ’¼" },
  { name: "Saeed Ullah Jan Marwat", role: "CEO", emoji: "ðŸ‘¨â€âš•ï¸" },
  { name: "Brigadier Ishfaq Ahmed", role: "Director", emoji: "ðŸ©º" },
  { name: "Mohammad Faisal", role: "Chief Operating Officer", emoji: "ðŸ‘©â€âš•ï¸" },
];

export const doctors = [
  { name: "Dr. Ahmed Al Mansouri", spec: "Cardiology", exp: "15 years", emoji: "ðŸ‘¨â€âš•ï¸" },
  { name: "Dr. Sarah Johnson", spec: "Obstetrics & Gynaecology", exp: "12 years", emoji: "ðŸ‘©â€âš•ï¸" },
  { name: "Dr. Khalid Ibrahim", spec: "Neurosurgery", exp: "18 years", emoji: "ðŸ§ " },
  { name: "Dr. Maria Santos", spec: "Dermatology", exp: "10 years", emoji: "ðŸ’†" },
  { name: "Dr. Mohammed Al Rashid", spec: "Orthopedics", exp: "14 years", emoji: "ðŸ¦´" },
  { name: "Dr. Priya Sharma", spec: "Pediatrics", exp: "11 years", emoji: "ðŸ‘¶" },
  { name: "Dr. James Wilson", spec: "Oncology", exp: "20 years", emoji: "ðŸ”¬" },
  { name: "Dr. Fatima Al Zaabi", spec: "Ophthalmology", exp: "9 years", emoji: "ðŸ‘ï¸" },
];

export const branches = [
  { name: "Main Hospital â€“ Deira", address: "Al Muteena Street, Deira, Dubai", phone: "+971 4 707 2222", emoji: "ðŸ¥" },
  { name: "Al Ghurair Centre Clinic", address: "Al Ghurair Centre, Deira, Dubai", phone: "+971 4 707 2200", emoji: "ðŸ¢" },
  { name: "Jumeirah Branch", address: "Jumeirah Beach Road, Dubai", phone: "+971 4 707 2233", emoji: "ðŸŒŠ" },
  { name: "Business Bay Clinic", address: "Business Bay, Dubai", phone: "+971 4 707 2244", emoji: "ðŸ™ï¸" },
];

export const aboutTabs = [
  {
    label: "Training",
    title: "Training & Education",
    content: "Capital Care Centre provides hands-on training and education programs for healthcare professionals and the community. Our sessions focus on practical skills, emergency preparedness, and up-to-date clinical guidelinesâ€”delivered by experienced instructors in a supportive learning environment.",
    img: "ðŸ«€",
  },
  {
    label: "Our Commitment to Patients",
    title: "Upholding Patient Interests with Compassionate Excellence",
    content: "At Capital Care Centre, patients come first. We are committed to safe, respectful, and timely careâ€”guided by medical ethics, clear communication, privacy, and informed decision-making. We listen, respond, and continually improve so every patient and family feels supported at every step.",
    img: "ðŸ¤",
  },
  {
    label: "Our Profile",
    title: "Comprehensive Care, Empowering Wellness",
    content: "Capital Care Centre is a patient-focused healthcare facility delivering comprehensive services across outpatient, inpatient, diagnostic, and emergency care. Our goal is to provide dependable, evidence-based treatment with modern facilities and a dedicated clinical teamâ€”focused on quality outcomes and patient comfort.",
    img: "ðŸ¥",
  },
  {
    label: "Governance",
    title: "Our Leadership & Governance",
    content: "Our governance framework supports accountability, transparency, and consistent quality across all services. Through clinical leadership, quality and safety oversight, and continuous performance review, Capital Care Centre works to maintain high standards and ensure care is delivered responsibly and reliably.",
    img: "âš–ï¸",
  },
];

export const values = [
  "Patient Safety", "Patient Satisfaction",
  "Customer-Centered Care", "Clinical Excellence",
  "Continuous Improvement", "Respect of All Beliefs",
  "Professionalism", "Team Work",
  "Open Communication", "Equal Opportunities",
  "Commitment to Our Community",
];

export const corporateServices = [
  "Annual Health Screenings",
  "On-site Medical Clinics",
  "Employee Assistance Programs",
  "Health Education Workshops",
  "Chronic Disease Management",
  "Mental Health Support",
];

export const contactInfo = [
  {
    key: "location",
    label: "Main Hospital",
    value: "G-8 Branch Capital Plaza, Islamabad, Pakistan",
    href: "https://www.google.com/maps/search/?api=1&query=G-8%20Branch%20Capital%20Plaza%2C%20Islamabad%2C%20Pakistan",
    external: true,
  },
  { key: "phone", label: "Phone", value: "+92 323-5159616", href: "tel:+923235159616" },
  { key: "email", label: "Email", value: "ccihisb@gmail.com", href: "mailto:ccihisb@gmail.com" },
  { key: "hours", label: "Working Hours", value: "Emergency: 24/7" },
];
